module.exports = __webpack_public_path__ + "static/media/usd-square.5a44b5a3.svg";